<template>
<div>
    <b-navbar 
      sticky 
      toggleable="lg" 
      type="dark" 
      variant="primary"
      class="mb-3"
    >
       <div class="col-4 ml-0">
        <b-navbar-brand
          left
          to="/"
          tag="h1"
          class="item-text"
        >
          <Logo />
        </b-navbar-brand>
      </div>
      <h1 class="mt-3" style="color: white !important">Support Issue {{ standalone }}</h1>
    </b-navbar>
    <Maintenance tablename="g_supportissues" :standalone="standalone" />
  </div>  
</template>
<script>
import Maintenance from './Maintenance.vue'
import Logo from './Logo'

export default {
    name: 'SupportIssue',
    components: {
        Maintenance,
        Logo,
    },
    data: function() {
      return {
        standalone: this.$route.params.id,
      }
    }
}
</script>
